import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


export const NavButton = ({ icon, label, path }) => {
    const handleNavigate = () => window.location.href = path
    return (
        <button
            className="nav-button"
            onClick={() => handleNavigate(path)}
        >
            <FontAwesomeIcon icon={icon} className="nav-icon" />
            <span className="button label">{label}</span>
        </button>
    )
}